(() => {
 function init() {
  const guide=document.getElementById('mo-wr-guide');if(!guide)return;
  const gallery=document.querySelector('[data-mo-wr-gallery]');
  if(gallery&&!gallery.dataset.ready){gallery.dataset.ready='1';gallery.querySelectorAll('[data-wr-thumb]').forEach(button=>button.addEventListener('click',()=>{
   gallery.querySelectorAll('[data-wr-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   gallery.querySelectorAll('[data-wr-photo]').forEach(p=>p.hidden=p.dataset.wrPhoto!==button.dataset.wrThumb);
  }));}
  const ready=document.getElementById('mo-wr-ready');
  const reviews=document.querySelector('.jdgm-review-widget')?.closest('.shopify-section');
  if(ready&&reviews&&reviews.nextElementSibling!==ready)reviews.after(ready);
  const form=document.querySelector('[data-product-form]'),table=document.getElementById('mo-wr-value');
  if(!form||!table||form.dataset.wrReady)return;form.dataset.wrReady='1';
  const product=JSON.parse(form.dataset.product);
  const currency=new Intl.NumberFormat(guide.dataset.locale||'en',{style:'currency',currency:form.dataset.shopCurrency||'USD'});
  function update(){
   const select=form.querySelector('[name="id"]');
   const selected=product.variants.find(v=>String(v.id)===select?.value);
   table.querySelectorAll('tbody tr').forEach(row=>{
    const variant=product.variants.find(v=>v.option1===row.dataset.wrSize&&(!selected||v.option2===selected.option2))||product.variants.find(v=>v.option1===row.dataset.wrSize);
    const grams=Number(row.dataset.wrGrams);if(!variant||!grams)return;
    row.querySelector('[data-wr-price]').textContent=currency.format(variant.price/100);
    row.querySelector('[data-wr-cost]').textContent=currency.format((variant.price/100)*100/grams);
   });
   const note=document.querySelector('.mo-wr-lead-time'),buttons=form.querySelector('.purchase-details__buttons');
   if(note&&buttons&&note.previousElementSibling!==buttons)buttons.after(note);
  }
  form.addEventListener('change',()=>setTimeout(update,0));form.addEventListener('click',()=>setTimeout(update,40));
  const observer=new MutationObserver(()=>{observer.disconnect();update();observer.observe(form,{childList:true,subtree:true});});
  observer.observe(form,{childList:true,subtree:true});update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
